export const GET_VEHICLE_GROUPS = "GET_VEHICLE_GROUPS";

export const UPDATE_VEHICLE_GROUPS_AFTER_ALLOCATE = "UPDATE_VEHICLE_GROUPS_AFTER_ALLOCATE";
export const SET_VEHICLE_GROUP_LOADING_STATUS = 'SET_VEHICLE_GROUP_LOADING_STATUS'